import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './index.css';
import { IoClose } from 'react-icons/io5';
import Footer from '../Footer';

import homeicon from '../../assests/karaicon.svg';
import sustainabilitysection1bg from '../../assests/sustainabilitysection1bg.png';
// Add your images for section 3
import sustainabilitySmallImage from '../../assests/sustainability-small.png'; // Replace with your image
import sustainabilitySection3Image from '../../assests/sustainability-main.png'; // Replace with your image

const Sustainability = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isConceptOpen, setIsConceptOpen] = useState(false);

const toggleConceptMenu = () => {
  setIsConceptOpen(!isConceptOpen);
};

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      {/* Navbar - Always Visible */}
      <nav className="sustainability-navbar">
        <div className="sustainability-navbar-logo">
          <Link to="/">
            <img src={homeicon} alt="Kara Logo" className="sustainability-logo-icon" />
          </Link>
        </div>
        <div className="sustainability-navbar-menu" onClick={toggleMenu}>
          <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none" className="sustainability-hamburger-icon">
            <circle cx="24.5" cy="24.5" r="24" fill="black" stroke="#9A9A9A"/>
            <rect x="13" y="16" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="23" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="30" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
          </svg>
        </div>
      </nav>

      {/* Navigation Menu Overlay */}
      {isMenuOpen && (
        <div className="sustainability-nav-overlay">
          <div className="sustainability-nav-close" onClick={toggleMenu}>
            <IoClose className="sustainability-close-icon" />
          </div>
          <nav className="sustainability-navigation">
            <ul className="sustainability-nav-list">
              <li><Link to="/about" onClick={toggleMenu}>About US</Link></li>
              <li><Link to="/process" onClick={toggleMenu}>Our Process</Link></li>
              <li><Link to="/services" onClick={toggleMenu}>Services</Link></li>
              <li><Link to="/collections" onClick={toggleMenu}>Collections & Products</Link></li>
              <li className="active"><Link to="/sustainability" onClick={toggleMenu}>Sustainability & Ethical Sourcing</Link></li>
              <li><Link to="/private-client" onClick={toggleMenu}>Private Client Services</Link></li>
              {/* <li><Link to="/hospitality" onClick={toggleMenu}>Hospitality & Commercial Solutions</Link></li>
              <li><Link to="/journal" onClick={toggleMenu}>Journal / Blog</Link></li> */}
              {/* <li className="nav-item-with-submenu">
                <span className="nav-concept-trigger" onClick={toggleConceptMenu}>
                  Concept <span className="dropdown-arrow">▼</span>
                </span>
                {isConceptOpen && (
                  <ul className="concept-submenu">
                    <li><Link to="/concept-1" onClick={toggleMenu}>Concept-1</Link></li>
                    <li><Link to="/concept-2" onClick={toggleMenu}>Concept-2</Link></li>
                  </ul>
                )}
              </li> */}
              <li><Link to="/concept" onClick={toggleMenu}>concept</Link></li>
              <li><Link to="/contact" onClick={toggleMenu}>Contact Us</Link></li>
            </ul>
          </nav>
        </div>
      )}

      {/* SECTION 1: Hero */}
      <section className="sustainability-section-1">
        {/* Background Image */}
        <div className="sustainability-section-1-background">
          <img src={sustainabilitysection1bg} alt="Sustainability Background" className="sustainability-section-1-bg-image" />
        </div>

        {/* Overlay */}
        <div className="sustainability-section-1-overlay"></div>

        {/* Bottom Content */}
        <div className="sustainability-section-1-content">
          <p className="sustainability-section-1-label">Sustainability & Ethical Sourcing</p>
          <h1 className="sustainability-section-1-title">
            Design That <br/>Gives Back
          </h1>
          <p className="sustainability-section-1-description">
            Studio Kãra creates beauty that goes beyond aesthetics—crafting products that restore, regenerate, and respect.
          </p>
        </div>
      </section>

      {/* SECTION 2: Commitment */}
      <section className="sustainability-section-2">
        <h2 className="sustainability-section-2-heading margin-top">
          Our Commitment to Regenerative Luxury
        </h2>
        <p className="sustainability-section-2-paragraph">
          We go beyond sustainability—crafting with purpose to heal <br/> the planet. <br/> From carbon-negative production methods to the use of reclaimed and responsibly sourced materials, every design choice at Studio Kara is a step toward a more conscious future. Our transparent processes ensure every piece has a story and every story leaves a positive impact.
        </p>
      </section>

      {/* SECTION 3: Content & Image */}
      <section className="sustainability-section-3">
        <div className="sustainability-section-3-container">
          {/* Left Content Div */}
          <div className="sustainability-section-3-content">
            <h2 className="sustainability-section-3-title">
              Sustainability as a Signature
            </h2>
            <p className="sustainability-section-3-description">
              Where timeless design meets environmental responsibility.We believe beauty should never come at the planet's expense. That's why we digitally trace our sourcing, offset more carbon than we emit, and give back through artisan support and reforestation initiatives. Sustainability isn't an add-on—it's embedded in our creative DNA.
            </p>
            <div className="sustainability-section-3-small-images">
              <img src={sustainabilitySmallImage} alt="Sustainable Design Detail" className="sustainability-small-image" />
            </div>
          </div>

          {/* Right Image Div */}
          <div className="sustainability-section-3-image-wrapper">
            <img src={sustainabilitySection3Image} alt="Sustainable Luxury" className="sustainability-section-3-main-image" />
          </div>
        </div>
      </section>

      <Footer/>
    </>
  );
};

export default Sustainability;